function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#222428;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Calque_2"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Calque_1"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M32.2,29.2L32,29l0-4.2l1.2-17.4l0-0.1l0,0c0.1-1.3-0.3-2.5-1.2-3.5c-0.9-1-2.1-1.6-3.4-1.8 c-2.7-0.2-5.1,1.8-5.4,4.5L23,9.9l-0.8-5l0-0.1l0-0.1c-0.5-2.7-3.1-4.5-5.8-4c-1.3,0.2-2.5,1-3.2,2c-0.7,0.9-1,2.1-0.9,3.2 c0,0.1,0,0.2,0,0.3l1.7,10.1c-0.3-0.1-0.7-0.1-1.1-0.1c-1.9,0-3.6,1.1-4.5,2.8c-0.8-0.4-1.6-0.7-2.5-0.7c-2.7,0-5,2.2-5,5v10.4 c0,10,8.1,18.1,18.1,18.1c5.3,0,15.1-3.4,15.1-11.6V34C34.3,32.5,34,30.5,32.2,29.2z M8.1,29c0,1.1-0.9,2-2,2s-2-0.9-2-2v-5.6 c0-1.1,0.9-2,2-2s2,0.9,2,2V29z M19.3,5.3l2.6,16.6l-0.7-0.5c-0.8-0.6-1.8-0.9-2.9-0.9c-0.1,0-0.2,0-0.3,0 c-0.1-0.4-0.2-0.7-0.3-1.1L15.4,6c-0.1-0.5,0-1,0.3-1.5C16,4.1,16.5,3.8,17,3.7C18.1,3.5,19.1,4.2,19.3,5.3z M15,21.7 c-0.3,0.3-0.6,0.6-0.8,0.9c-0.8,1.1-1.1,2.4-0.8,3.7c0.2,1.1,0.8,2.2,1.6,2.9c-0.1,1-1,1.7-2,1.7c-1.1,0-2-0.9-2-2v-7.7 c0-1.1,0.9-2,2-2s2,0.9,2,2V21.7z M17.6,31.1l4.1,2.9c0.1,0,0.1,0.1,0.1,0.2c0,0.1,0,0.1-0.1,0.2c-3.3,2.3-5.3,5.9-5.3,9.7 c0,0.8,0.7,1.5,1.5,1.5c0.8,0,1.5-0.7,1.5-1.5c0-2.8,1.5-5.6,4-7.2c0.9-0.6,1.4-1.6,1.4-2.7c0-1.1-0.5-2.1-1.4-2.7l-6.2-4.4 c-0.4-0.3-0.7-0.8-0.8-1.3c-0.1-0.5,0-1,0.3-1.5c0.6-0.9,1.9-1.1,2.8-0.5l11,7.8c0.4,0.3,0.8,0.7,0.8,2.4v6.1 c0,6.1-7.9,8.6-12.1,8.6c-8.3,0-15.1-6.8-15.1-15.1v-0.2c0.6,0.3,1.3,0.4,2,0.4c1.3,0,2.6-0.5,3.5-1.4c0.9,0.9,2.2,1.4,3.5,1.4 C15,33.9,16.8,32.8,17.6,31.1z M28.4,5.1c0.5,0,1,0.3,1.3,0.7c0.3,0.4,0.5,0.9,0.5,1.5L29,24.7l0,2.2l-4.4-3.1 c0.1-0.1,0.2-0.2,0.3-0.4c0.1-0.1,0.1-0.2,0.1-0.3l1.3-16.2C26.4,5.8,27.3,5,28.4,5.1z"
}));

var SvgAbout = function SvgAbout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 38.6 52.7",
    style: {
      enableBackground: "new 0 0 38.6 52.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAbout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/about.d6e4a524.svg";
export { ForwardRef as ReactComponent };